<template>
  <div>
    <ul class="password-rules__list">
      <li v-for="(rule, index) in UTD_PASSWORD_RULES" :key="index">
        <p class="password-rules__item">
          {{ rule.text }}
        </p>
        <div v-if="rule.subText" class="password-rules__item password-characters">
          <span v-for="(char, idx) in rule.subText" 
                :key="idx"
                role="img"
                :title="char.name">
            {{ char.text }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { UTD_PASSWORD_RULES } from '_acaSrc/utility/constants';
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.password-rules__list {
  .ds1-reset-p();
  .ds1-utd-size-2();
  .ds1-pl-2();
}

.password-rules__item {
  .ds1-reset-p();
}

.password-characters {
  .ds1-pl-2();
  display: flex;
  gap: 6px;
}

</style>